<template>
  <div class="col-12">
    <div class="row d-flex justify-content-between mb-0">
      <div class="tag-badge ">
        <span class="dot text-center pl-1">
          <i :class="page.icon" class="orange-icon orange-icon-badge-align"></i>
        </span>
        <span class="tag-badge-title py-1 pl-2">{{ page.title }}</span>
      </div>
    </div>
    <div v-if="hasRoute" class="row mt-2 controls-wrap">
      <div class="col-12">
        <div class="nav-text mt-1">
          Usted se encuentra aqu&iacute;:
          <span v-for="(item, index) in page.routes" :key="index">
            <a :class="{ 'nav-text-current': index === page.routes.length - 1 }" class="nav-text-link">
              {{ item }}
              <span v-if="!(index === page.routes.length - 1)"> / </span>
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  meta: {
    description: 'Incluye dos componentes comunes, BreadCrumb.vue y Title.vue',
    slots: {
      default: {
        type: 'component',
        valid: [],
      }
    },
  },
  props: {
    page: {
      type: Object,
      default: () => {},
      meta: {
        description: 'Estable el icono y título.',
        example: 'Objeto Requerido',
      }
    },
    hasRoute: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Ruta entre las páginas',
        example: 'true',
      }
    }
  }
};
</script>

<style scoped>
.tag-badge {
  display: flex;
  align-items: center;
  padding-right: 1em;
  height: 43px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  margin-bottom: 10px;
}

.dot {
  width: 41px;
  height: 41px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
  font-size: 18pt;
  padding-right: 4px;
  line-height: 25px;
  margin-left: 0px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
  margin-left: 10px
}

/*text for navigation*/
.nav-text {
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;

}

.nav-text-link {
  color: black;
  font-weight: 400;
  text-decoration: none;
}
.nav-text-link:hover {
  color: black;
  text-decoration: none;
  font-weight: 800;
}
.nav-text-current {
  color: black;
  font-weight: 700;
  text-decoration: none;
}
.nav-text-current:hover {
  color: black;
  text-decoration: none;
  font-weight: 800;
}
</style>
